<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <adhoc-drive-list-filter />
      <adhoc-drive-list-header />
      <adhoc-drive-list-table />
    </div>
  </div>
</template>

<script>

export default {
  name: 'AdhocDriveList',
  computed: {
  }
}
</script>

<style>

</style>
